import { CLOUD_CTRL_FALLBACK_URL, isProd } from '@shared/env';
import { HTTP } from '@shared/utils/http';
import { mergeWith } from 'lodash-es';
import { withLocalPageConfigPresets } from './pageConfigPresets';
import {
	type ConfigData,
	type RawConfigData,
	RawConfigDataResponseSchema,
	resolveConfigData,
} from './type';

const defaultConfigFile = isProd
	? await import('./default.prod.json')
	: await import('./default.json');

const defaultConfigSource = withLocalPageConfigPresets(defaultConfigFile.data);
const localConfig = resolveConfigData(defaultConfigSource);

const buildConfig = (
	remoteConfig?: Partial<RawConfigData>,
	testConfig?: Partial<RawConfigData>,
): ConfigData => {
	const mergedConfig = mergeWith(
		{},
		defaultConfigSource,
		remoteConfig,
		testConfig,
		(_objValue, srcValue) => {
			if (Array.isArray(srcValue)) {
				return srcValue;
			}

			return undefined;
		},
	);
	const validateResult = RawConfigDataResponseSchema.safeParse({ data: mergedConfig });

	if (!validateResult.success) {
		console.error('controller config resolve failed, fallback to local config');
		return localConfig;
	}

	return resolveConfigData(validateResult.data.data);
};

const getConfigData = async (): Promise<ConfigData> => {
	// 优先使用中间件数据
	if (window.feConfig) {
		window.feConfig = buildConfig(window.feConfig, window.testConfig);
		return window.feConfig;
	}
	// 本地开发用本地的
	if (!isProd) {
		console.log('使用本地数据');
		window.feConfig = buildConfig(undefined, window.testConfig);
		return window.feConfig;
	}
	// 兜底中的兜底，中间件工作不正常的情况（一般不会触发
	try {
		console.log('使用云数据');
		const res = await HTTP.get<RawConfigData>({ url: CLOUD_CTRL_FALLBACK_URL });
		window.feConfig = buildConfig(res.data, window.testConfig);
		return window.feConfig;
	} catch {
		window.feConfig = buildConfig(undefined, window.testConfig);
		return window.feConfig;
	}
};

export default await getConfigData();
